import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Wrench, PackageOpen, Truck, Hammer, Tv, Smartphone, Users, Drill, PaintBucket, Lightbulb, DoorOpen, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Services = () => {
  const serviceCategories = [
    {
      category: 'Home Repairs & Maintenance',
      icon: <Wrench className="w-8 h-8" />,
      services: [
        'Door repairs and adjustments',
        'Window repairs',
        'Drywall repair and patching',
        'Caulking and weatherproofing',
        'Deck and fence repairs',
        'General home maintenance'
      ]
    },
    {
      category: 'Installation Services',
      icon: <Hammer className="w-8 h-8" />,
      services: [
        'Light fixtures and ceiling fans',
        'Cabinet hardware',
        'Shelving and closet organizers',
        'Curtain rods and blinds',
        'Door hardware and locks',
        'Bathroom accessories'
      ]
    },
    {
      category: 'Assembly & Moving',
      icon: <PackageOpen className="w-8 h-8" />,
      services: [
        'Furniture assembly (IKEA, etc.)',
        'Furniture disassembly for moving',
        'Moving help and heavy lifting',
        'Loading and unloading trucks',
        'Rearranging furniture',
        'Appliance moving'
      ]
    },
    {
      category: 'Mounting & Hanging',
      icon: <Tv className="w-8 h-8" />,
      services: [
        'TV mounting (all sizes)',
        'Picture and mirror hanging',
        'Artwork installation',
        'Floating shelves',
        'Heavy item mounting',
        'Wall-mounted desks'
      ]
    },
    {
      category: 'Smart Home & Tech',
      icon: <Smartphone className="w-8 h-8" />,
      services: [
        'Smart doorbell installation',
        'Smart lock setup',
        'Security camera mounting',
        'Smart thermostat installation',
        'Wi-Fi extender setup',
        'Cable management'
      ]
    },
    {
      category: 'General Labor',
      icon: <Users className="w-8 h-8" />,
      services: [
        'Extra hands for any job',
        'Yard work and cleanup',
        'Garage organization',
        'Seasonal projects',
        'Event setup and breakdown',
        'General handyman tasks'
      ]
    }
  ];

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Our <span className="text-red-500">Services</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From quick fixes to major projects, we handle it all with skill and professionalism.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {serviceCategories.map((category, index) => (
              <Card 
                key={index}
                className="bg-black/50 border-red-900/30 hover:border-red-500 transition-all duration-300"
              >
                <CardContent className="p-8">
                  <div className="flex items-center mb-6">
                    <div className="text-red-500 mr-4">
                      {category.icon}
                    </div>
                    <h3 className="text-2xl font-bold" style={{ color: '#FFD700' }}>
                      {category.category}
                    </h3>
                  </div>
                  <ul className="space-y-3">
                    {category.services.map((service, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="w-2 h-2 bg-red-500 rounded-full mr-3 mt-2 flex-shrink-0"></span>
                        <span className="text-gray-300">{service}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Don't See Your Service Listed?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            If a specific service isn't listed, that doesn't mean we don't offer it. <br />
            Give us a call and we'll tell you the best next step.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:8134491138"
              className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 py-4 rounded-md text-lg transition-all duration-300 inline-block"
            >
              Call (813) 449-1138
            </a>
            <a 
              href="/#contact"
              className="border-2 border-white text-white hover:bg-white hover:text-black font-semibold px-8 py-4 rounded-md text-lg transition-all duration-300 inline-block"
            >
              Request a Quote
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
